import React from 'react';
import styled from "styled-components";
import Colours from "../atoms/Colours";
import { BodyLarge, BodyRegular } from "../atoms/fonts/Body";
import { selectIsAdvanceHotDeskingLoading } from '@features/desks/store/advanceHotDeskingSetup.duck';
import { useDispatch, useSelector } from "react-redux";
import { LoadingSpinner } from "../atoms/LoadingSpinner";
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import { failureNotification } from '@shared/store/notification.duck';
import { useTranslation } from "react-i18next";
import { Moment } from "moment";
import { CapacityResponse } from '@features/desks/services/OfficeCapacityService';
import { WithOfficeCapacity } from "../organisms/weekly-movements-setter/hooks/WithCapacity";

interface Props {
  onClick: any;
  floor: OfficeEntity;
  activeDate: Moment;
  capacity: CapacityResponse;
}

export default function FloorLocationContentCard(props: Props) {
  const {capacity} = props;
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsAdvanceHotDeskingLoading);
  const {t} = useTranslation();

  const officeUsage = WithOfficeCapacity(capacity);

  const click = () => {
    if (officeUsage > 0) {
      props.onClick();
    } else if (officeUsage < 1) {
      dispatch(failureNotification('That floor is full'));
    } else {
      TrackJS?.track('Unknown error - floorLocationContentCard')
      dispatch(failureNotification('Unknown error'));
    }
  }

  return (
    <>
      {isLoading && <LoadingSpinner fullScreen={true}/>}
      <OfficeContentCard onClick={click} data-test={'floor-location-content-card'}>
        <OfficeDetails>
          <BodyLarge weight={600} style={{lineHeight: '26px'}}>{props.floor.label}</BodyLarge>
          <BodyRegular>{officeUsage === 0.5 && <span>&#189;</span>}{t('whereabouts.seats-available', {remaining: officeUsage === 0.5 ? '' : officeUsage})}</BodyRegular>
        </OfficeDetails>
      </OfficeContentCard>
    </>
  );
}

const OfficeDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding-left: 16px;
`

const OfficeContentCard = styled.div`
  box-shadow: 0px 9px 22px 0px rgba(46, 74, 148, 0.08);
  padding: 24px 32px;
  border-radius: 12px;
  border: 1px solid ${Colours.lightGrey};
  background: white;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  cursor: pointer;
  margin: 0 8px 24px 8px;
  position: relative;
`
